var map = {
	"./White-Bishop.svg": 20230,
	"./White-King.svg": 87206,
	"./White-Knight.svg": 87017,
	"./White-Pawn.svg": 13875,
	"./White-Queen.svg": 12287,
	"./White-Rook.svg": 28649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58383;